import axiosInstance from './axiosConfig';
import {
  VideoGenerationJob,
  VideoJobDetailResponse,
} from './videoGenerationService';

export interface BannerVideoJob extends VideoGenerationJob {
  source_image_id: number;
  source_video_id?: number | null;
  source_width?: number;
  source_height?: number;
  output_width?: number;
  output_height?: number;
  duration_seconds?: number;
  resolution?: string;
  progress_step?: string;
  progress_percentage?: number;
  instruction?: string | null;
}

export interface BannerVideoEntry {
  job: BannerVideoJob;
  video: VideoJobDetailResponse['video'];
}

export interface CreateBannerVideoRequest {
  source_image_id: number;
  source_video_id?: number;
  instruction?: string;
  client_request_id: string;
}

const normalizeEntry = (entry: BannerVideoEntry): BannerVideoEntry => {
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8003/api';
  const storageUrl = apiUrl.replace(/\/api\/?$/, '');
  return {
    ...entry,
    video: entry.video
      ? {
          ...entry.video,
          url: entry.video.url.replace(
            /^http:\/\/localhost\/storage\//,
            `${storageUrl}/storage/`
          ),
        }
      : null,
  };
};

const bannerVideoService = {
  async getForImage(imageId: number): Promise<BannerVideoEntry[]> {
    const { data } = await axiosInstance.get<{ jobs: BannerVideoEntry[] }>(
      `/videos/from-banner/${imageId}`
    );
    return data.jobs.map(normalizeEntry).reverse();
  },

  async create(request: CreateBannerVideoRequest): Promise<BannerVideoEntry> {
    const { data } = await axiosInstance.post<
      BannerVideoEntry & { success: boolean; message?: string }
    >(
      '/videos/from-banner',
      {
        ...request,
        video_model: 'fal-h3-max-turbo',
        duration_seconds: 8,
        resolution: '720p',
      },
      { timeout: 60000 }
    );
    if (!data.success || !data.job)
      throw new Error(data.message || '動画の生成を開始できませんでした。');
    return normalizeEntry(data);
  },
};

export default bannerVideoService;
